import React, {useRef} from "react";
import {useAppDispatch, useAppSelector} from "@hooks/redux-hooks/hooks";
import {selectToken} from "@commons/core.slice";
import {logout} from "@commons/actions/authentication.action";
import {IconAlertTriangle, IconDoorExit} from "@tabler/icons-react";

interface SessioneScadutaProps {

}

const SessioneScaduta: React.FC<SessioneScadutaProps> = () => {
    const dispatch = useAppDispatch();
    const token = useAppSelector(selectToken);
    const cancelButtonRef = useRef(null)
    const scollegati = () => dispatch(logout(token?.token!));

    return (
        <div className="overflow-hidden rounded-lg bg-white text-left shadow-xl sm:my-8 sm:w-full sm:max-w-lg">
            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                        <IconAlertTriangle className="h-6 w-6 text-red-600" aria-hidden="true"/>
                    </div>
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                        <h3 className="text-lg font-medium leading-6">
                            Sessione scaduta
                        </h3>
                        <div className="mt-2">
                            <p className="text-sm text-gray-500">
                                La tua sessione &egrave; scaduta per inoperativit&agrave;. Per accedere rifare la login.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                    onClick={scollegati}
                    ref={cancelButtonRef}
                >
                    Logout&nbsp;<IconDoorExit size={19}/>
                </button>
            </div>
        </div>
    )
}
export default SessioneScaduta;